module.exports = __webpack_public_path__ + "img/modalback.0f8b09a4.png";